import { useTranslation } from "react-i18next";
import React, {FunctionComponent, useEffect} from 'react';
import {Button, Col, DatePicker, Form, Row, Typography} from "antd";
import {DeleteOutlined, FilterOutlined} from "@ant-design/icons";
import {get} from "lodash";
import {useForm} from "antd/es/form/Form";
import {FormInstance} from "antd/lib";
import FormItemDropdown from '../../../../../components/form-dropdown/FormItemDropdown';
import { dataStatus } from '../../constants/data';
import "./filter-group.scss";
import { globalStore } from '../../../../../stores/stores';
import { Permission } from '../../../../../layout/sidebar/permission.enum';

type FormFilterProps = {
  showFilter?: boolean
  clearFilter: (form: FormInstance) => void,
  onFinish?: any,
  dataOptions?: any
}

const FormFilter: FunctionComponent<FormFilterProps> = ({ onFinish, showFilter, clearFilter, dataOptions }) => {
  const { t } = useTranslation();
  const [form] = useForm();
  const { RangePicker } = DatePicker;
  const { personalInfo } = globalStore();
  const permissions = personalInfo?.permissions;

  useEffect(() => {
    const university = dataOptions?.dataUniversity?.find((item: any) => item?.uuid === personalInfo?.enterpriseUUID) as any;
    if(permissions?.includes(Permission.isQTCS)) {
      form.setFieldValue("university", university?.id)
    }
  }, [personalInfo, dataOptions?.dataUniversity]);

  return (
    <>
      <div className={`wrapper-filter ${showFilter ? "open" : ""}`}>
        <Form name="filterForm" onFinish={onFinish} form={form}>
          <Row gutter={[{xs: 8, xl: 24, md: 16}, 12]}>
            <Col xl={{span: 6}} md={{span: 5}} sm={{span: 5}} xs={{span: 24}}>
              <Typography.Title level={5}>{t('Thời gian', 'Thời gian')}</Typography.Title>
              <Form.Item name="time">
                <DatePicker.RangePicker allowEmpty={[true, true]} placeholder={[t("Bắt đầu", "Bắt đầu"), t("Kết thúc", "Kết thúc")]} format='DD/MM/YYYY' />
              </Form.Item>
            </Col>
            {/* <Col xl={{span: 6}} md={{span: 5}} sm={{span: 5}} xs={{span: 24}}>
              <Typography.Title level={5}>{t("Đối tượng", "Đối tượng")}</Typography.Title>
              <Form.Item name="user">
                <FormItemDropdown placeholder={t("Chọn đối tượng", "Chọn đối tượng")} options={get(dataOptions, 'dataUser', '')} disabled={permissions?.includes(Permission.isQTCS)}/>
              </Form.Item>
            </Col> */}
            <Col xl={{span: 3}} md={{span: 9}} sm={{span: 9}} xs={{span: 24}} className="flex align-end">
              <div className="group-btn--filter">
                <Button className="btn btn-primary filter-btn" htmlType="submit">
                  <FilterOutlined/>
                  <Typography.Text> {t('Lọc', 'Lọc')} </Typography.Text>
                </Button>
                <Button className="btn btn-outlined clear-filter-btn" onClick={() => clearFilter(form)}>
                  <DeleteOutlined/>
                  <Typography.Text> {t('Xóa bộ lọc', 'Xóa bộ lọc')} </Typography.Text>
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </div>
    </>
  );
};

export default FormFilter;
